import React from 'react';

interface CenterCardProps {
  readonly title: string;
  readonly children?: React.ReactNode;
}

function CenterCard({ title, children }: Readonly<CenterCardProps>) {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md rounded-xl border border-gray-200 bg-white p-6 shadow-lg text-center">
        <h2 className="m-0 text-[20px] font-semibold text-gray-900 text-center">
          {title}
        </h2>
        <div className="mt-3">{children}</div>
      </div>
    </div>
  );
}

export default CenterCard;
